/* eslint new-cap: ['error', { 'capIsNew': false }]*/
import { createStore, applyMiddleware } from 'redux';
import { sessionReducer } from './session.store';
import { passwordResetReducer } from './passwordReset.store';
import { rolesConfigReducer } from './rolesconfig.store';
import { reportsConfigReducer } from './reportsconfig.store';
import { errorReducer } from './error.store';
import { usersInfoReducer, usersSelectReducer } from '../component/managment/users/user.store';
import { pricesDbReducer } from '../store/pricesdb.store';
import { cutoffDatesReducer } from '../store/cutoffdates.store';
import { refReducer } from '../component/dict/simple/simple.store';
import { storeStatusReducer } from './storeForStoringStatusOfStores.store';
import { linksReducer, linksQuantityReducer, linksOrderReducer, atomsReducer } from './links.store';
import { eventsListReducer, eventsEditReducer,
  todayEventListReducer, eventReducer } from '../component/calendar/calendar.store';
import createEngine from 'redux-storage-engine-localstorage';
import merger from 'redux-storage-merger-immutablejs';
import * as storage from 'redux-storage';
import { routerMiddleware, LOCATION_CHANGE } from 'react-router-redux';
import { browserHistory } from 'react-router';
import filter from 'redux-storage-decorator-filter';
import Immutable, { Map, List, fromJS } from 'immutable';
import { REF_NAME as DELIVERY_TERM_REF_NAME }
  from '../component/dict/simple/deliveryterm/Const';
import { REF_NAME as PACKING_REF_NAME }
  from '../component/dict/simple/packing/Const';
import { REF_NAME as ORIGIN_REF_NAME }
  from '../component/dict/simple/origin/Const';
import { REF_NAME as SUPPLIER_REF_NAME }
  from '../component/dict/simple/supplier/Const';
import { REF_NAME as PORT_REF_NAME }
  from '../component/dict/simple/port/Const';
import { REF_NAME as BUYER_REF_NAME }
  from '../component/dict/simple/buyer/Const';
import { REF_NAME as EXPENSESTYPE_REF_NAME }
  from '../component/dict/complex/expensestype/Const';
import { REF_NAME as EXPENSECATEGORY_REF_NAME }
  from '../component/dict/simple/expensecategory/Const';
import { REF_NAME as PRODUCER_REF_NAME }
  from '../component/dict/simple/producer/Const';
import { REF_NAME as OWNER_REF_NAME }
  from '../component/dict/simple/owner/Const';
import { REF_NAME as VESSEL_BROKER_REF_NAME }
  from '../component/dict/simple/vesselbroker/Const';
import { REF_NAME as FORWARDER_REF_NAME }
  from '../component/dict/simple/forwarder/Const';
import { REF_NAME as SHIPPINGLINE_REF_NAME }
  from '../component/dict/simple/shippingline/Const';
import { REF_NAME as LOADING_TERM_REF_NAME }
  from '../component/dict/simple/loadingterm/Const';
import { REF_NAME as BANK_REF_NAME }
  from '../component/dict/simple/bank/Const';
import { REF_NAME as DOCUMENTTYPE_REF_NAME }
  from '../component/dict/simple/documenttype/Const';
import { REF_NAME as INSPECTIONCOMPANY_REF_NAME }
  from '../component/dict/simple/inspectioncompany/Const';
import { REF_NAME as INSURANCECOMPANY_REF_NAME }
  from '../component/dict/simple/insurancecompany/Const';
import { REF_NAME as CURRENCY_TERM_REF_NAME }
  from '../component/dict/currency/Const';
import { REF_NAME as COMMONCOUNTERPARTIES_REF_NAME }
  from '../component/dict/simple/commoncounterparties/Const';
import { REF_NAME as TRADE_COUNTERPARTIES_REF_NAME }
  from '../component/dict/simple/tradecounterparties/Const';
import { REF_NAME as REGION_REF_NAME }
  from '../component/dict/simple/region/Const';
import { REF_NAME as PORT_GROUP_REF_NAME }
  from '../component/dict/simple/portgroup/Const';
import { REF_NAME as TOPMANAGER_REF_NAME }
  from '../component/dict/simple/topmanager/Const';
import { REF_NAME as PAYMENT_METHOD_REF_NAME }
  from '../component/dict/simple/paymentmethod/Const';
import { refReducer as productReducer } from '../component/dict/complex/product/store';
import { allAroundReducer } from './allaround.store';
import { dealsListReducer } from '@/component/blogic/deals/store/deals.store.js';
import { dealEditReducer } from '@/component/blogic/deals/store/deal.store.js';
import { dealsFilesReducer } from '@/component/blogic/deals/store/files.store.js';
import metadataReducer from '@/component/metadata/metadata.store.js';
import { dealPortsReducer } from '@/component/blogic/deals/store/ports.store.js';
import { locksReducer } from './collaboration.js';
import { bugReportsReducer } from './debuginfo/debuginfo.store.js';
import { userMetricsReducer } from './usermetrics.store.js';
import { searchReducer, sortReducer } from '@/component/blogic/deals/store/search.store.js';
import { globalSearchReducer } from '@/component/blogic/deals/store/globalsearch.store.js';
import { scrollReducer } from './scroll.store';
import { interestRateReducer } from '@/component/managment/interestrate/interestrate.store.js';
import { currenciesReducer } from '@/component/currencies/currencies.store';
import { todaysPaymentsReducer } from '@/component/blogic/reports/store/TodaysPayments.store';
import { unlinkedRegionsReducer } from '@/component/blogic/reports/store/UnlinkedRegions.store';
import { positionBookReducer } from '@/component/blogic/reports/store/PositionBook.store';
import { openPositionReducer } from '@/component/blogic/reports/store/OpenPosition.store';
import { profitabilityReducer } from '@/component/blogic/reports/store/Profitability.store';
import { supplyDemandReducer } from '@/component/blogic/reports/store/SupplyDemand.store';
import { volumeReportReducer } from '@/component/blogic/reports/store/VolumeReport.store';
import { unifiedDealsReducer } from '@/component/blogic/reports/store/UnifiedDeals.store';
import { notificationReducer } from './notification.store';
import { portCoordinatesReducer } from '@/component/blogic/reports/store/PortCoordinates.store';
import { paymentsReportReducer } from '@/component/blogic/reports/store/PaymentsReport.store';
import { pltabReducer } from '@/component/blogic/deals/store/pltab.store';
import { finTabReducer } from '@/component/blogic/deals/store/finTab.store';
import { performanceReportReducer } from '@/component/blogic/reports/store/PerformanceReport.store';
import { analyticsReportReducer } from '@/component/blogic/reports/store/AnalyticsReport.store';
import { userPerformanceReportReducer }
  from '@/component/blogic/reports/store/UserPerformanceReport.store';
import { buyerCarinsuranceReducer } from '../component/dict/simple/buyer/buyerCarInsurance.store';
import { multiNodalReportReducer } from '../component/blogic/reports/store/MultiNodalReport.store';
import { earningStatementsReportReducer }
  from '../component/blogic/reports/store/EarningStatements.store';

// debug info
import combineReducers from './debuginfo/devtools.combineReducers';
import './debuginfo/exception.interceptor';
import './debuginfo/warning.interceptor';
import './debuginfo/promiserejection.interceptor';

import { composeWithDevTools } from 'redux-devtools-extension';


const engine = filter(createEngine('application-state-storage'),
  [
    'whitelisted-key',
    ['session'],
    ['portCoordinates'],
    ['allaround', 'changelogVersion'],
  ],
  [
    'blacklisted-key',
    ['routing', 'data', 'pricesdb'],
  ]);
const middleware = storage.createMiddleware(engine, [],
  ['LOGIN_SUCCESSFUL', 'LOGOUT', 'SAVED_NEW_CHANGELOG_VERSION', 'UPDATE_PORT_CACHE']);

const storageAwareReducer = (state = Map(), action) => {
  switch (action.type) {
    case storage.LOAD:
      return state.set('loaded', true);
    default:
      return state;
  }
};

const initialState = Immutable.fromJS({
  locationBeforeTransitions: null,
  stateHistory: {
    payload: [],
  },
});

export const fallThrough = (dispatch, name, payload, emulationKey) =>
  dispatch({ type: 'LOCATION_FALL_THROUGH', name, payload, emulationKey });
export const fallThroughReturn = (dispatch, pointIdx) =>
  dispatch({ type: 'LOCATION_FALL_THROUGH_RETURN', pointIdx });
export const fallThroughClear = (dispatch, emulationKey) =>
  dispatch({ type: 'LOCATION_FALL_CLEAR', emulationKey });
export const fallThroughPop = dispatch =>
  dispatch({ type: 'LOCATION_FALL_THROUGH_POP' });
export const fallThroughInitial = (dispatch, name, payload) =>
  dispatch({ type: 'INITIAL_FALL_THROUGH', name, payload });

const routeReducer = (state = initialState, action) => {
  if (action.type == LOCATION_CHANGE) {
    return state.merge({
      locationBeforeTransitions: action.payload,
      changeIdx: state.get('changeIdx', 0) + 1,

      // processing route transition
      transition: false,
    });
  }
  switch (action.type) {
    // eslint-disable-next-line
    case 'LOCATION_FALL_THROUGH':
      if (state.get('transition')) {
        return state;
      }
      const emulationKey = action.emulationKey;
      const newItem = fromJS({
        payload: action.payload,
        name: action.name && action.name.trim ? action.name.trim() : action.name,
        idx: emulationKey ? null : state.get('changeIdx', 0),
        emulationKey: emulationKey || null,
      });
      if (!emulationKey) {
        const itemIdx = state.get('falls', new List())
          .findIndex(item => item.get('idx', 0) == state.get('changeIdx', 0));
        if (itemIdx >= 0) {
          if (newItem.equals(state.getIn(['falls', itemIdx]))) {
            return state;
          }
          return state.set('falls', state.get('falls', new List()).set(itemIdx, newItem));
        }
      }
      return state.set('falls', state.get('falls', new List()).push(newItem));
    case 'INITIAL_FALL_THROUGH':
      return state.set('falls', List.of(fromJS({
        name: action.name,
        payload: action.payload,
        idx: state.get('changeIdx', 0),
      })));
    case 'LOCATION_FALL_THROUGH_POP':
      return state.set('falls', state.get('falls', new List()).pop().pop()).set('transition', true);
    case 'LOCATION_FALL_THROUGH_RETURN':
      return state.set('falls', state.get('falls').slice(0, action.pointIdx));
    case 'LOCATION_FALL_CLEAR':
      if (action.emulationKey) {
        return state.set('falls', state.get('falls', new List())
          .filter(item => item.get('emulationKey') != action.emulationKey));
      }
      return state.set('falls', new List());
    default:
      return state;
  }
};

const superReducer = combineReducers({
  session: sessionReducer,
  passwordReset: passwordResetReducer,
  rolesconfig: rolesConfigReducer,
  reportsconfig: reportsConfigReducer,
  storage: storageAwareReducer,
  pricesdb: pricesDbReducer,
  cutoffdates: cutoffDatesReducer,
  allaround: allAroundReducer,
  notifications: notificationReducer,
  storeStatus: storeStatusReducer,
  links: combineReducers({
    data: linksReducer,
    quantity: linksQuantityReducer,
    order: linksOrderReducer,
    atoms: atomsReducer,
  }),
  metadata: metadataReducer,
  data: combineReducers({
    currencies: currenciesReducer,
    users: usersInfoReducer,
    users_select: usersSelectReducer,
    locks: locksReducer,
    deals: combineReducers({
      list: dealsListReducer,
      deal: dealEditReducer,
      files: dealsFilesReducer,
      ports: dealPortsReducer,
      pltab: pltabReducer,
      fintab: finTabReducer,
    }),
    events: combineReducers({
      otherdata: eventReducer,
      list: eventsListReducer,
      edit: eventsEditReducer,
      today: todayEventListReducer,
    }),
    reports: combineReducers({
      todaysPayments: todaysPaymentsReducer,
      unlinkedRegions: unlinkedRegionsReducer,
      positionBook: positionBookReducer,
      openPosition: openPositionReducer,
      profitabilityReport: profitabilityReducer,
      volumeReport: volumeReportReducer,
      unifiedDeals: unifiedDealsReducer,
      payments: paymentsReportReducer,
      performance: performanceReportReducer,
      supplyDemand: supplyDemandReducer,
      analytics: analyticsReportReducer,
      userPerformance: userPerformanceReportReducer,
      multiNodal: multiNodalReportReducer,
      earningStatements: earningStatementsReportReducer,
    }),
  }),
  references: combineReducers({
    values: combineReducers({
      buyer: combineReducers({
        insurancebuyers: buyerCarinsuranceReducer,
      }),
    }),
    simple: combineReducers({
      packing: refReducer(PACKING_REF_NAME),
      deliveryterm: refReducer(DELIVERY_TERM_REF_NAME),
      origin: refReducer(ORIGIN_REF_NAME),
      supplier: refReducer(SUPPLIER_REF_NAME),
      port: refReducer(PORT_REF_NAME),
      buyer: refReducer(BUYER_REF_NAME),
      expensestype: refReducer(EXPENSESTYPE_REF_NAME),
      expensecategory: refReducer(EXPENSECATEGORY_REF_NAME),
      owner: refReducer(OWNER_REF_NAME),
      vesselbroker: refReducer(VESSEL_BROKER_REF_NAME),
      forwarder: refReducer(FORWARDER_REF_NAME),
      shippingline: refReducer(SHIPPINGLINE_REF_NAME),
      loadingterm: refReducer(LOADING_TERM_REF_NAME),
      bank: refReducer(BANK_REF_NAME),
      producer: refReducer(PRODUCER_REF_NAME),
      documenttype: refReducer(DOCUMENTTYPE_REF_NAME),
      insurancecompany: refReducer(INSURANCECOMPANY_REF_NAME),
      inspectioncompany: refReducer(INSPECTIONCOMPANY_REF_NAME),
      topmanager: refReducer(TOPMANAGER_REF_NAME),
      commoncounterparties: refReducer(COMMONCOUNTERPARTIES_REF_NAME),
      tradecounterparty: refReducer(TRADE_COUNTERPARTIES_REF_NAME),
      region: refReducer(REGION_REF_NAME),
      portgroup: refReducer(PORT_GROUP_REF_NAME),
      paymentmethod: refReducer(PAYMENT_METHOD_REF_NAME),
    }),
    complex: combineReducers({
      product: productReducer,
    }),
    currency: combineReducers({
      currency: refReducer(CURRENCY_TERM_REF_NAME),
    }),
    interestrate: interestRateReducer,
  }),
  search: combineReducers({
    globalsearch: globalSearchReducer,
    purchase: searchReducer('purchase'),
    sale: searchReducer('sale'),
    transport: searchReducer('transport'),
    payments: searchReducer('payments'),
    transportBulkPayment: searchReducer('transportBulkPayment'),
  }),
  sort: combineReducers({
    purchase: sortReducer('purchase'),
    sale: sortReducer('sale'),
    transport: sortReducer('transport'),
  }),
  scroll: scrollReducer,
  routing: routeReducer,
  error: errorReducer,
  usage: userMetricsReducer,
  bugreports: bugReportsReducer,
  portCoordinates: portCoordinatesReducer,
  locationBeforeTransitions: (state = {}) => state, // dummy reducer to prevent from throwing error
});

const reducer = storage.reducer(superReducer, merger);

const composeEnhancers = composeWithDevTools({
  maxAge: 5,
  latency: 3000,
});

const createStoreWithMiddleware = composeEnhancers(
  applyMiddleware(
    middleware,
    routerMiddleware(browserHistory),
  ),
)(createStore);

const store = createStoreWithMiddleware(reducer);

export const load = storage.createLoader(engine);

load(store);

export default store;

// retard style javascript
document.addEventListener('visibilitychange', () => {
  load(store);
});
